import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpParams, HttpRequest } from '@angular/common/http';
import { from, Observable } from 'rxjs';
import { catchError, exhaustMap, take } from 'rxjs/operators';
import { AuthService, NotificationSenderService } from '@shared/services';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    
    constructor(private authService: AuthService, private notificationService: NotificationSenderService) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return this.authService.token.pipe(
            take(1),
            exhaustMap(token => {
                let reqNuevo = req;

                if(token){
                    reqNuevo = req.clone({ params: new HttpParams().set('auth', token) });
                }

                return next.handle(reqNuevo).pipe(
                    catchError(error => from(this.handleError(error)))
                );
            })
        );
    }

    private async handleError(err: any): Promise<any> {
        if (err.status >= 400 && err.status < 500) {
            const message = this.getErrorMessage(err.error.error.message);
            this.notificationService.notifyError(message);
            return;
        }
        if (err.status >= 500) {
            this.notificationService.notifyError("An unexpected error has occurred. Please try again.");
            return;
        }

        throw err;
    }

    private getErrorMessage(code: string): string {
        let message = "An unexpected error has occurred. Please try again.";

        if (code.startsWith("WEAK_PASSWORD")) {
            message = "Password should be at least 6 characters"; 
        }
        if (code.startsWith("EMAIL_EXISTS")) {
            message = "The email address is already in use. Try signing in."; 
        }
        if (code.startsWith("TOO_MANY_ATTEMPTS_TRY_LATER")) {
            message = "All requests from this device have been block due to unusual activity. Try again later."; 
        }
        if (code.startsWith("INVALID_LOGIN_CREDENTIALS") ||
            code.startsWith("EMAIL_NOT_FOUND") || 
            code.startsWith("INVALID_PASSWORD")
        ) {
            message = "Wrong email or password.";
        }
        if (code.startsWith("USER_DISABLED")) {
            message = "The user account has been disabled. Please contact an administrator."; 
        }
        
        return message;
    }
}
